import { getInstance } from "./index";

export const authGuard = (to, from, next) => {
  const authService = getInstance();

  const fn = () => {
    if (!authService.isAuthenticated) {
      let config = { appState: { targetUrl: to.fullPath } };
      if (to.path == "/signup") {
        config = { appState: { targetUrl: "/" }, screen_hint: "signup" };
      }
      authService.loginWithRedirect(config);
      return;
    } else if (to.path == "/signup") {
      return next("/");
    }

    if (
      !to.meta.allowMembers &&
      !(authService.isAdmin() || authService.isManager())
    ) {
      return next("/");
    }
    if (to.meta.onlyAdmin && !authService.isAdmin()) {
      return next("/");
    }

    return next();
  };

  // If loading has already finished, check the auth state using `fn()`
  if (!authService.loading) {
    return fn();
  }

  // Watch for the loading property to change before checking isAuthenticated
  authService.$watch("loading", loading => {
    if (loading === false) {
      return fn();
    }
  });
};
